<template>
	<div>
		<component v-bind:is="componentFile" 
      :option="option" 
      :studentOpportunityAdditionalMaterialId="studentOpportunityAdditionalMaterialId"
      :studentOpportunityId="studentOpportunityId"
      :is-first="isFirst" 
      :is-last="isLast"
      :asuriteId="asuriteId"
      :callback="callback"
      @submitted="submit()"
      @previous="previous()"></component>
	</div>
</template>

<script>
export default {
  props: {
    componentName: {
      type: String,
      required: true
    },
    option: {
      type: Object,
      required: true
    },
    studentOpportunityAdditionalMaterialId: {
      type: Number,
      required: true
    },
    studentOpportunityId: {
      type: Number,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    },
    asuriteId: {
      type: String,
      required: false
    },
    callback: {
      type: String,
      required: false
    }
  },
  computed: {
    componentFile() {
      return () =>
        import(`../placements/additional-materials/${this.componentName}.vue`);
    }
  },
  methods: {
    submit: function() {
      this.$emit("submitted");
    },
    previous: function() {
      this.$emit("previous");
    }
  }
};
</script>
